import { Auth } from '../../configuration/react';

export class SignProviderApp {
  static getToken() {
    return Auth.token();
  }

  static async refreshToken() {
    await Auth.refreshToken();
  }
}
